<template>
  <div>
    <div v-if="asyncDataStatus_ready" class="cms">
      <form @submit.prevent>
        <v-row justify="space-between">
          <v-col cols="12" sm="10" md="6">
            <v-row>
              <v-col cols="12">
                <DateTimeSelector
                  labelDate="Od"
                  :date="startDate"
                  :time="startTime"
                  @change="updateStartDateTime"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <DateTimeSelector
                  labelDate="Do"
                  :date="endDate"
                  :time="endTime"
                  @change="updateEndDateTime"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-select
                  :items="showOptions"
                  item-text="name"
                  item-value="val"
                  v-model="showOption"
                  return-object
                  label="Filtri prikaza"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="enableClients">
              <v-col cols="6">
                <v-autocomplete
                    v-model="clientId"
                    :items="clients"
                    label="Izberi klienta"
                    item-text="name"
                    ref="name"
                    auto-select-first
                    return-object
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-select
                  :items="paymentTypesWithNull"
                  item-text="name"
                  item-value="val"
                  v-model="paymentType"
                  label="Način plačila"
                ></v-select>
              </v-col>
            </v-row>
            <!-- <v-row>
              <v-col>
                <FormErrors
                  v-if="$v.clientId.$error && (!$v.clientId.required)"
                >
                  <FormErrorsLine v-if="!$v.clientId.required" text="Polje je obvezno" />
                </FormErrors>
              </v-col>
            </v-row> -->
          </v-col>
          <v-col cols="12" md="auto">
            <v-row>
              <v-col cols="12">
                <v-btn
                  color="#0F998E"
                  class="white--text mt-2 float-right d-inlineblock"
                  @click="showpdf"
                >
                  PDF
                  <v-icon right dark>fa-solid fa-search</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn
                  color="#0F998E"
                  class="white--text mt-2 float-right d-inlineblock"
                  @click="showexcel"
                >
                  Excel
                  <v-icon right dark>fa-solid fa-search</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import FormErrors from '@/components/FormErrors'
import { required } from 'vuelidate/lib/validators'
import FormErrorsLine from '@/components/FormErrorsLine'
import { objectToArray } from '@/utils/object'
import DateTimeSelector from '@/components/DateTimeSelector'
import InvoiceCard from '@/components/InvoiceCard'
import PopupInvoicePreviewWithActions from '@/components/PopupInvoicePreviewWithActions'
import PopupCancelInvoice from '@/components/PopupCancelInvoice'
import PopupCanceledInvoceComment from '@/components/PopupCanceledInvoceComment'
import PopupChangeInvoice from '@/components/PopupChangeInvoice'
import PrintControlTape from '@/components/PrintControlTape'
import printJS from 'print-js'

export default {
  components: {
    FormErrors,
    FormErrorsLine,
    InvoiceCard,
    DateTimeSelector,
    PopupInvoicePreviewWithActions,
    PopupCancelInvoice,
    PopupChangeInvoice,
    PopupCanceledInvoceComment,
    PrintControlTape
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      base64excel: null,
      paymentTypesWithNull: [],
      paymentType: null,
      showOptions: [],
      showOption: null,
      startDate: '',
      startTime: '00:00',
      endDate: '',
      endTime: '23:59',
      loading: false,
      clientId: null,
      resolveFunc: null,
      typingTimer: null,
      enableClients: false,
      doneTypingInterval: 700
    }
  },
  validations () {
    return {
      startDate: { required },
      endDate: { required },
      clientId: {
        required: function () {
          return this.isClientIdRequired
        }
      }
    }
  },
  computed: {
    isClientIdRequired() {
      return this.showOption && this.showOption.val === 'action';
    },
    clients () {
      return objectToArray(this.$store.state.clients.items)
    },
    businessUnitId () {
      return this.$store.state.businessUnits.currentBusinessUnit.id
    },
    businessUnit () {
      return this.$store.state.businessUnits.currentBusinessUnit
    },
    paymentTypes () {
      return Object.values(this.$store.state.paymentTypes.items)
    },
    params () {
      return {
        dateFrom: moment(`${this.startDate} ${this.startTime}:00`).format('YYYY-MM-DDTHH:mm:ss'),
        dateTo: moment(`${this.endDate} ${this.endTime}:59`).format('YYYY-MM-DDTHH:mm:ss'),
        clientOnly: this.showOption.val,
        clientId : this.clientId,
        paymentType: this.paymentType,
      }
    }
  },
  methods: {
    ...mapActions('companies', ['businessRegister']),
    ...mapActions('clients', ['loadItems']),
    ...mapActions('paymentTypes', { loadPaymentTypes: 'loadItems' }),
    ...mapActions('invoices', ['getInvocesExcel']),
    showpdf () {
      /* this.$v.$touch()
      if (!this.$v.$error) { */
      let params = this.params
      let routeData = this.$router.resolve({ name: 'MyCompanyGlobalInvoicesPreview', query: {
        dateFrom: params.dateFrom,
        dateTo: params.dateTo,
        clientOnly: params.clientId
          ? true
          : params.clientOnly,
        clientId: params.clientId
          ? params.clientId.id
          : null,
        paymentType: params.paymentType } })
      window.open(routeData.href, '_blank')
      // }
    },
    showexcel() {
      const params = this.params
      this.getInvocesExcel({
          dateFrom: params.dateFrom,
          dateTo: params.dateTo,
          clientOnly: params.clientId ? true : params.clientOnly,
          client: params.clientId ? params.clientId.id : null,
          paymentType: params.paymentType
      })
        .then(response => {
          const responseItems = response
          this.asyncDataStatus_fetched()
          this.base64excel = responseItems.data
          this.fileName = responseItems.filename

          const blob = this.base64ToBlob(
            response.data,
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          )
          this.triggerDownload(blob, this.fileName)
        })
        .catch(anErr => {
          console.log(anErr)
          this.$notify({
            type: 'error',
            text: 'Prišlo je do napake pri izpisu računov.'
          })
        })
    },
    triggerDownload(blob, fileName) {
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(link.href)
    },
    base64ToBlob(base64, mimeType) {
      const byteCharacters = atob(base64)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      return new Blob([byteArray], { type: mimeType })
    },
    updateStartDateTime ({ date, time }) {
      this.startDate = date
      this.startTime = time
    },
    updateEndDateTime ({ date, time }) {
      this.endDate = date
      this.endTime = time
    }
  },
  async created () {
    if (!this.$store.state.businessUnits.currentBusinessUnit) {
      this.$notify({ type: 'error', text: 'Potrebna je vsaj ena aktivna poslovna enota' })
    } else {
      const yesterday = moment().add(-1, 'days').format('YYYY-MM-DD')
      const today = moment().format('YYYY-MM-DD')
      this.startDate = yesterday
      this.endDate = today
      this.showOptions.push({
        name: 'Vsi računi',
        val: false
      })
      this.showOptions.push({
        name: 'Računi s klientom',
        val: true
      })
      this.showOptions.push({
        name: 'Računi z izbranim klientom',
        val: 'action'
      })
      this.paymentTypesWithNull.push({
        name: 'Vsi tipi plačila',
        val: null
      })
      await this.loadItems()
      await this.loadPaymentTypes()
      this.paymentTypes.forEach(ptype => {
        this.paymentTypesWithNull.push({
          name: `${ptype.name}`,
          val: ptype.id
        })
      })
      this.showOption = this.showOptions[1]
      this.asyncDataStatus_fetched()
    }
  },
  watch: {
    async showOption (option) {
      this.$v.clientId.$touch()
      if (option.val == 'action') {
        await this.loadItems()
        this.clients = this.clients
        this.enableClients = true
      } else {
        this.enableClients = false
        this.clientId = null
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.print-a4-invoice {
  display: none;
}
@media print {
  .print-a4-invoice {
    display: block;
  }
}

.print-control-tape {
  display: none;
}
@media print {
  .print-control-tape {
    display: block;
    font-size: 10px;
  }
}
</style>

<style lang="scss">
@media print {
  .cms,
  .header,
  .v-navigation-drawer,
  .footer {
    display: none;
  }
  .v-content {
    padding: 0px !important;
  }
}
</style>
